module.exports = __webpack_public_path__ + "img/slogan.aa930dc3.png";